import apiEndpoints from 'api/endpoints';

import { baseAPI } from './baseApi';

export const settingsApi = baseAPI.injectEndpoints({
    endpoints: (builder) => ({
        toggleWebhookAuthToken: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.setWebhookAuthToken,
                method: 'PUT',
                body: payload,
            }),
        }),
        fetchWebhookAuthToken: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.getWebhookAuthToken,
                method: 'POST',
                body: payload,
            }),
        }),
        fetchCustomSenderEmail: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.settings.customSenderEmail.default}/?companyUUID=${payload.companyUUID}`,
                method: 'GET',
            }),
        }),
        modifyCustomSenderEmail: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.settings.customSenderEmail.default,
                method: payload.method,
                body: payload.data,
            }),
        }),
        removeCustomSenderEmail: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.settings.customSenderEmail.default,
                method: 'DELETE',
                body: payload,
            }),
        }),
        changeAccountPassword: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.updatePassword,
                method: 'POST',
                body: payload,
            }),
        }),
        modifyMedallionNotificationStatus: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.settings.email,
                method: 'POST',
                body: payload,
            }),
        }),
        fetchCompanyWebhook: builder.query({
            query: () => ({
                url: apiEndpoints.addWebhookUrl,
                method: 'GET',
            }),
        }),
        modifyCompanyWebhook: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.addWebhookUrl,
                method: 'POST',
                body: payload,
            }),
        }),
        fetchCompanyApiKey: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.accessCode,
                method: 'POST',
                body: payload,
            }),
        }),
        fetchCompanyAdmins: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.getAdmins,
                method: 'POST',
                body: payload,
            }),
        }),
        createCompanyMember: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.createNewMember,
                method: 'POST',
                body: payload,
            }),
        }),
        updateCompanyMember: builder.mutation({
            query: (payload) => ({
                url: `admin/company/admin-account/${payload.uac}/update`,
                method: 'POST',
                body: payload,
            }),
        }),
        resendCompanyMemberInvitation: builder.mutation({
            query: (payload) => ({
                url: `admin/company/admin-account/${payload.uac}/resend-invite`,
                method: 'POST',
                body: payload,
            }),
        }),
        reActivateCompanyMember: builder.mutation({
            query: (payload) => ({
                url: `admin/company/admin-account/${payload.uac}/re-activate`,
                method: 'POST',
                body: payload,
            }),
        }),
        changeCompanyMemberRole: builder.mutation({
            query: (payload) => ({
                url: `admin/company/admin-account/${payload.uac}/change-role`,
                method: 'POST',
                body: payload,
            }),
        }),
        suspendCompanyMember: builder.mutation({
            query: (payload) => ({
                url: `admin/company/admin-account/${payload.uac}/suspend`,
                method: 'POST',
                body: payload,
            }),
        }),
    }),
});

export const {
    useFetchWebhookAuthTokenMutation: useFetchWebhookAuthToken,
    useToggleWebhookAuthTokenMutation: useToggleWebhookAuthToken,
    useFetchCustomSenderEmailMutation: useFetchCustomSenderEmail,
    useModifyCustomSenderEmailMutation: useModifyCustomSenderEmail,
    useRemoveCustomSenderEmailMutation: useRemoveCustomSenderEmail,
    useChangeAccountPasswordMutation: useChangeAccountPassword,
    useModifyMedallionNotificationStatusMutation: useModifyMedallionNotificationStatus,
    useFetchCompanyWebhookQuery: useFetchCompanyWebhook,
    useModifyCompanyWebhookMutation: useModifyCompanyWebhook,
    useFetchCompanyApiKeyMutation: useFetchCompanyApiKey,
    useFetchCompanyAdminsMutation: useFetchCompanyAdmins,
    useCreateCompanyMemberMutation: useCreateCompanyMember,
    useUpdateCompanyMemberMutation: useUpdateCompanyMember,
    useResendCompanyMemberInvitationMutation: useResendCompanyMemberInvitation,
    useReActivateCompanyMemberMutation: useReActivateCompanyMember,
    useChangeCompanyMemberRoleMutation: useChangeCompanyMemberRole,
    useSuspendCompanyMemberMutation: useSuspendCompanyMember,
} = settingsApi;

export default settingsApi.middleware;
